import type {PinIdentifier} from '../../../../../types';
import type {AvailablePin} from '../../../../types';

import {dateToReadableDate} from '@date-picker';
import {Checkbox, Chip} from '@ds/components';
import {getStatusChipProps} from 'common/status-chip/getStatusChipProps';
import {numberFormat} from 'utils/Helper';

import {PIN_AVAILABILITY_LABELS} from '../../../../../constants';

type AvailablePinItemProps = {
  item: AvailablePin;
  selectedPins: PinIdentifier[];
  onToggle: (pinId: PinIdentifier) => void;
};

const AvailablePinItem: React.FC<AvailablePinItemProps> = ({item, selectedPins, onToggle}) => {
  const state = item.state ?? '';
  const isUnavailable = state === 'reserve' || state === 'purchased';
  const isSelected = selectedPins.includes(item.available_pin_id) && state !== 'purchased';
  const chipProps = getStatusChipProps(state);

  return (
    <div className="flex items-center">
      <Checkbox
        aria-label={`انتخاب بسته ${item.activate_date ?? ''}`}
        checked={isSelected}
        disabled={isUnavailable}
        onChange={() => onToggle(item.available_pin_id)}
      />
      <div className="flex min-w-0 flex-1 items-center justify-between gap-3 border-b border-gray-03 py-2.5 last:border-b-0 ps-4">
        <div className="flex min-w-0 flex-col gap-1">
          <span className="text-body-sm-emphasis text-neutral-fg">
            {dateToReadableDate({
              date: item.activate_date ?? '',
              day: true,
              month: true
            })}
          </span>
          <div className="flex items-center gap-2 text-body-sm text-neutral-fg">
            {!item.discount ? <span>از {numberFormat(item.price ?? 0)} تومان</span> : null}
            {item.percentage ? (
              <span className="rounded-md bg-destructive px-1.5 text-destructive-on">
                {item.percentage}%
              </span>
            ) : null}
            {item.discount ? (
              <>
                <span className="text-gray-04 line-through">{numberFormat(item.discount)}</span>
                <span>{numberFormat(item.original ?? 0)} تومان</span>
              </>
            ) : null}
          </div>
        </div>
        {state && state !== 'free' ? (
          <Chip
            label={PIN_AVAILABILITY_LABELS[state] ?? state}
            variant={chipProps.variant}
            color={chipProps.color}
            size="sm"
            interactive={false}
          />
        ) : null}
      </div>
    </div>
  );
};

export default AvailablePinItem;
